"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAssuranceTheme = void 0;
var styles_1 = require("@mui/material/styles");
var deepmerge_1 = __importDefault(require("@mui/utils/deepmerge"));
var palette_1 = require("./colors/palette");
/**
 * Generate a MUI theme with Assurance Design System defaults, based on the options received.
 * @param overrides Takes an incomplete theme object and overrides Assurance defaults.
 * @returns A complete, ready-to-use theme object.
 */
var createAssuranceTheme = function (overrides) {
    if (overrides === void 0) { overrides = {}; }
    return (0, styles_1.createTheme)((0, deepmerge_1.default)({
        palette: palette_1.palette,
    }, overrides));
};
exports.createAssuranceTheme = createAssuranceTheme;
